<template>
  <el-dialog
      :visible.sync="visible"
      title="设置存货工厂"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <el-form-item label="存货仓库：" prop="storeFactory">
        <company v-model="dataForm.storeFactory" :clearable="true"/>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <div style="display: flex; justify-content: space-between;align-items: center; width: 100%;">
        <div style="color:red;font-weight: bold;">
          设置存货工厂后《订单结算》成本摊销方式会发生变化,外销合同请确认后再进行设置
        </div>
        <div>
          <el-button @click="visible = false">取消</el-button>
          <el-button type="primary" @click="dataFormSubmitHandle">确定</el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'change-store-factory',
  data () {
    return {
      dataForm: {
        id: '',
        storeFactory: '',
      },
      visible: false,
      dataRule: {
        storeFactory: [
          { required: true, message: '请选择工厂', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    init (id) {
      this.dataForm = {
        id: id,
        storeFactory: ''
      }
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    async dataFormSubmitHandle () {
      const res = await this.$api2.post('/trade/order/changeStoreFactory', this.dataForm)
      this.$emit('changed')
      this.$message.success('保存成功')
      this.visible = false
    }
  }
}
</script>

<style scoped>

</style>
